import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetLicenseGenerateDataResponse } from '@/api/type/types';

/** 라이선스 키 발급시 필요한 정보 조회 */
export const getLicenseGenerateData = async () => {
  const res = await api.get<ApiResponseType<GetLicenseGenerateDataResponse>>(
    `/api/web/admins/license-keys/generation-data`
  );
  return res.data;
};
